import { htmlLang, type Lang } from "@/lib/i18n/config";

/** Formaterar publiceringsdatum på valt språk. */
export function formatPublished(value: string | null | undefined, lang: Lang = "sv"): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(htmlLang(lang), {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Europe/Stockholm",
  });
}


/** Kort relativ text, t.ex. "i dag", "3 dagar sedan". */
export function relativePublished(value: string | null | undefined, lang: Lang = "sv"): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const days = Math.floor((Date.now() - d.getTime()) / 86_400_000);
  if (days < 30) {
    return new Intl.RelativeTimeFormat(htmlLang(lang), { numeric: "auto" }).format(-Math.max(0, days), "day");
  }
  return formatPublished(value, lang);
}

/** Datum och klockslag i svensk tid, t.ex. "22 aug 2026 kl. 00:06". */
export function formatDateTime(value: string | null | undefined, lang: Lang = "sv"): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const locale = htmlLang(lang);
  const date = d.toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Europe/Stockholm",
  });
  const time = d.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Stockholm",
  });
  return lang === "sv" ? `${date} kl. ${time}` : `${date}, ${time}`;
}

/** Relativ tid med minuter och timmar, t.ex. "för 5 min sedan". */
export function timeAgo(value: string | null | undefined, lang: Lang = "sv"): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const seconds = Math.floor((Date.now() - d.getTime()) / 1000);
  const relative = new Intl.RelativeTimeFormat(htmlLang(lang), { numeric: "auto" });
  if (seconds < 60) return relative.format(0, "second");
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return relative.format(-minutes, "minute");
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return relative.format(-hours, "hour");
  const days = Math.floor(hours / 24);
  if (days < 30) return relative.format(-days, "day");
  return formatPublished(value, lang);
}

